import type { MapGameMode } from "$lib/types";

/** Static mapping of map keys to their Overwatch game mode type. */
export const MAP_GAME_MODES: Record<string, MapGameMode> = {
    // Control
    "antarctic-peninsula": "control",
    busan: "control",
    ilios: "control",
    "lijiang-tower": "control",
    nepal: "control",
    oasis: "control",
    samoa: "control",

    // Escort
    "circuit-royal": "escort",
    dorado: "escort",
    havana: "escort",
    junkertown: "escort",
    rialto: "escort",
    "route-66": "escort",
    "shambali-monastery": "escort",
    "watchpoint-gibraltar": "escort",

    // Hybrid
    "blizzard-world": "hybrid",
    eichenwalde: "hybrid",
    hollywood: "hybrid",
    "kings-row": "hybrid",
    midtown: "hybrid",
    "neon-junction": "hybrid",
    numbani: "hybrid",
    paraiso: "hybrid",

    // Push
    colosseo: "push",
    esperanca: "push",
    "new-queen-street": "push",
    runasapi: "push",

    // Flashpoint
    aatlis: "flashpoint",
    "new-junk-city": "flashpoint",
    suravasa: "flashpoint",
};

/** Display names for map game mode types. */
export const MAP_GAME_MODE_LABELS: Record<MapGameMode, string> = {
    control: "Control",
    escort: "Escort",
    hybrid: "Hybrid",
    push: "Push",
    flashpoint: "Flashpoint",
    clash: "Clash",
};

/**
 * Ordered list of game mode types for consistent display.
 * New types can be appended without breaking existing code.
 */
export const MAP_GAME_MODE_ORDER: MapGameMode[] = ["control", "escort", "hybrid", "push", "flashpoint", "clash"];
